import * as angular from "angular";
import {AgentReference} from "../../agents/angular/models/agentReference.model";
import {AgentModel} from "../../agents/angular/models/agent.model";
import {ReportsRequests} from "./reports-requests.service";

export class ReportsDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private splitService, private moment) {
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  deliveriesFilters(event, range, demandIds, supplyIds, agentIds, groupBy) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/deliveries-filters-dialog.html').default,
      controller: function ($scope) {

        $scope.siteId = self.splitService.getSiteId();
        $scope.range = {
          dateStart: new Date(range.dateStart),
          dateEnd: new Date(range.dateEnd)
        };
        $scope.demandIds = angular.copy(demandIds);
        $scope.supplyIds = angular.copy(supplyIds);
        $scope.agentIds = angular.copy(agentIds);
        $scope.groupBy = angular.copy(groupBy);

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onChangeDemandIds = (ids) => {
          $scope.demandIds = ids;
        }

        $scope.onChangeSupplyIds = (ids) => {
          $scope.supplyIds = ids;
        }

        $scope.onChangeAgentIds = (ids) => {
          $scope.agentIds = ids;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              const payload = {
                range: {
                  dateStart: self.moment($scope.range.dateStart).startOf('day').valueOf(),
                  dateEnd: self.moment($scope.range.dateEnd).endOf('day').valueOf()
                },
                demandIds: $scope.demandIds,
                supplyIds: $scope.supplyIds,
                agentIds: $scope.agentIds,
                groupBy: $scope.groupBy
              };
              self.$mdDialog.hide(payload);
            }

          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  agentsFilters(event, range, agentIds, groupBy) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/agents-filters-dialog.html').default,
      controller: function ($scope) {

        $scope.siteId = self.splitService.getSiteId();
        $scope.range = {
          dateStart: new Date(range.dateStart),
          dateEnd: new Date(range.dateEnd)
        };
        $scope.agentIds = angular.copy(agentIds);
        $scope.groupBy = angular.copy(groupBy);

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onChangeAgentIds = (ids) => {
          $scope.agentIds = ids;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              const payload = {
                range: {
                  dateStart: self.moment($scope.range.dateStart).startOf('day').valueOf(),
                  dateEnd: self.moment($scope.range.dateEnd).endOf('day').valueOf()
                },
                agentIds: $scope.agentIds,
                groupBy: $scope.groupBy
              };
              self.$mdDialog.hide(payload);
            }

          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  vendorsFilters(event, range, supplyIds, groupBy) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/vendors-filters-dialog.html').default,
      controller: function ($scope) {

        $scope.siteId = self.splitService.getSiteId();
        $scope.range = {
          dateStart: new Date(range.dateStart),
          dateEnd: new Date(range.dateEnd)
        };
        $scope.supplyIds = angular.copy(supplyIds);
        $scope.groupBy = angular.copy(groupBy);

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onChangeSupplyIds = (ids) => {
          $scope.supplyIds = ids;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              const payload = {
                range: {
                  dateStart: self.moment($scope.range.dateStart).startOf('day').valueOf(),
                  dateEnd: self.moment($scope.range.dateEnd).endOf('day').valueOf()
                },
                supplyIds: $scope.supplyIds,
                groupBy: $scope.groupBy
              };
              self.$mdDialog.hide(payload);
            }

          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  agentRoutesPerformanceDialog(agent, agentRoutesPerformance, from, to) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/agent-routes-performance-dialog.html').default,
      controller: function ($scope, $state) {

        $scope.agent = agent;
        $scope.agentRoutesPerformance = agentRoutesPerformance;

        $scope.from = from;
        $scope.to = to;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////////

        $scope.onRedirectToAgentReport = () => {
          $state.go('reports.performance.routes-accuracy-drivers', {agentIds: [agent.id], from: from, to: to})
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }


}

angular
  .module('bringoz.admin.reports')
  .service('reportsDialogService', ReportsDialogService);
